import { Mark, mergeAttributes } from '@tiptap/core';
import { POST_EDITOR_TEXT_COLOR_LEGACY_TOKENS } from '../lib/post_editor_constants.js';

export const PS_TEXT_COLOR_TOKEN_ATTR = 'data-ps-text-color';

export function normalizePsTextColorToken(token) {
  if (!token) return null;
  const normalized = token.toString().trim().toLowerCase();
  if (!normalized) return null;
  return POST_EDITOR_TEXT_COLOR_LEGACY_TOKENS.has(normalized) ? `ps-${normalized}` : normalized;
}

export const PsTextColorExtension = Mark.create({
  name: 'psTextColor',

  // Render outside underline so `<span class="ps-text-color"><u>…</u></span>` inherits color.
  priority: 200,

  addAttributes() {
    return {
      token: {
        default: null,
        parseHTML: (element) => {
          const explicit = element.getAttribute?.(PS_TEXT_COLOR_TOKEN_ATTR);
          if (explicit) return normalizePsTextColorToken(explicit);

          const classAttr = element.getAttribute?.('class') || '';
          const match = classAttr.match(/\bps-text-color--([a-z0-9-]+)\b/i);
          return match ? normalizePsTextColorToken(match[1]) : null;
        },
        renderHTML: (attributes) => {
          const token = normalizePsTextColorToken(attributes.token);
          if (!token) return {};
          return { [PS_TEXT_COLOR_TOKEN_ATTR]: token };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span',
        getAttrs: (element) => {
          const classAttr = element.getAttribute?.('class') || '';
          const tokenAttr = element.getAttribute?.(PS_TEXT_COLOR_TOKEN_ATTR);
          if (tokenAttr) return {};
          if (/\bps-text-color--[a-z0-9-]+\b/i.test(classAttr)) return {};
          return false;
        },
      },
    ];
  },

  renderHTML({ mark, HTMLAttributes }) {
    const token = normalizePsTextColorToken(mark?.attrs?.token || HTMLAttributes[PS_TEXT_COLOR_TOKEN_ATTR]);
    const classes = ['ps-text-color'];
    if (token) classes.push(`ps-text-color--${token}`);

    // Drop the `token` attribute from merged HTML attrs to avoid serializing it as `token="..."`
    const { token: _token, ...rest } = HTMLAttributes;
    if (token) rest[PS_TEXT_COLOR_TOKEN_ATTR] = token;
    return [
      'span',
      mergeAttributes(rest, {
        class: classes.join(' '),
      }),
      0,
    ];
  },
});

export default PsTextColorExtension;
